var _rect, _path, _line, _line2, _line3, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcVisaMore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: 0.4,
    width: 14.2,
    height: 12.2,
    stroke: "white",
    strokeWidth: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10.125V10.5H2.5V10.125C2.5 10.0388 2.52082 9.96701 2.56275 9.89886C2.60712 9.82672 2.66055 9.77751 2.72757 9.74211C3.01718 9.59765 3.30851 9.4907 3.60192 9.41974C3.89677 9.34842 4.19596 9.31268 4.5003 9.3125C4.80424 9.31232 5.10302 9.348 5.3975 9.4196C5.69138 9.49105 5.98312 9.59816 6.27305 9.74242C6.33987 9.77755 6.39313 9.82652 6.4374 9.89859C6.47944 9.96703 6.5001 10.0387 6.5 10.1244V10.125ZM4.5 8C4.28991 8 4.12251 7.93103 3.97074 7.77926C3.81897 7.62749 3.75 7.46009 3.75 7.25C3.75 7.03991 3.81897 6.87251 3.97074 6.72074C4.12251 6.56897 4.28991 6.5 4.5 6.5C4.71009 6.5 4.87749 6.56897 5.02926 6.72074C5.18103 6.87251 5.25 7.03991 5.25 7.25C5.25 7.46009 5.18103 7.62749 5.02926 7.77926C4.87749 7.93103 4.71009 8 4.5 8Z",
    fill: "white",
    stroke: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 6.75,
    x2: 13,
    y2: 6.75,
    stroke: "white",
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 7.75,
    x2: 11,
    y2: 7.75,
    stroke: "white",
    strokeWidth: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 8.75,
    x2: 11,
    y2: 8.75,
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84541 4.4268L7.84544 4.42676L8.48776 3.65598C8.4755 3.73362 8.4541 3.80973 8.42388 3.88268C8.37363 4.00401 8.29997 4.11425 8.20711 4.20711C8.11425 4.29997 8.00401 4.37363 7.88268 4.42388C7.8658 4.43087 7.84874 4.4374 7.83154 4.44344L7.84541 4.4268ZM7.69894 2.51999L7.65459 2.5732L7.28852 3.0124L6.95125 2.67498L6.64522 2.98101C6.6864 2.91317 6.73585 2.84994 6.79289 2.79289C6.98043 2.60536 7.23478 2.5 7.5 2.5C7.56698 2.5 7.63362 2.50673 7.69894 2.51999Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVisaMore);
export default __webpack_public_path__ + "static/media/ic_visa_more.3c1e22a5086fadd653fa21580519c6fd.svg";
export { ForwardRef as ReactComponent };